import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user")) || null;
    if (user) {
      if (user.accessToken && user.userRole[0] === "ADMIN") {
        navigate("/admin");
      } else if (user.accessToken && user.userRole[0] === "SUPERADMIN") {
        navigate("/superadmin-dashboard");
      } else if (user.accessToken) {
        navigate("dashboard");
      }
    }
  }, []);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/signin`,
        { username: data.username, password: data.password }
      );
      if (res.data.userRole[0] === "SUPERADMIN") {
        navigate("/superadmin-dashboard");
      } else if (res.data.userRole[0] === "ADMIN") {
        const org = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${res.data.username}`,
          { headers: { Authorization: `Bearer ${res.data.accessToken}` } }
        );
        // localStorage.setItem("org", JSON.stringify(org.data.orgId));
        localStorage.setItem("org", JSON.stringify(org.data.orgId));
        if (!org.data.orgUsername && !org.data.orgShortform) {
          navigate(`/admin/org-details`);
        } else {
          navigate(`/admin`);
        }
      } else {
        navigate("/dashboard");
      }
      localStorage.setItem("user", JSON.stringify(res.data));
    } catch (error) {
      setError("Login failed. Invalid user ID or password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App" style={{ position: "relative" }}>
      {loading && <div className="loading-div"></div>}
      <div className="border-container">
        <div style={{ position: "absolute", left: 50, display: 'flex', alignItems: 'center' }}>
          <img src="/assets/pic1.png" alt="Nobel Logo" width={400} />
        </div>
        <div style={{ position: "absolute", right: 50, display: 'flex', alignItems: 'center' }}>
          <img src="/assets/pic2.png" alt="Nobel Logo" width={400} />
        </div>

        <img src="/assets/nobel-01.jpg" alt="Nobel Logo" width={100} />
        <h2>
          Welcome to <br /> Nobel AMS <br /> (Approval Matrix System)
        </h2>
        <form>
          {/* <Typography variant="h4" mb={5}>
            Login
          </Typography> */}
          <label htmlFor="username">Email ID</label>
          <input
            type="email"
            name="username"
            id="username"
            onChange={handleChange}
          />
          <label htmlFor="password">Password</label>
          <input
            type="password"
            name="password"
            id="password"
            onChange={handleChange}
          />
          {error && <span className="error">{error}</span>}
          <div style={{ display: "flex", justifyContent: "end" }}>
            <a href="/forgot-password" style={{ fontSize: "12px" }}>
              Forgot Password?
            </a>
          </div>
          <Button
            className="btn-contained"
            fullWidth
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Login;
